<template>
  <b-container fluid>
    <b-row class="p-3">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <h4>{{ title }}</h4>
      </div>

      <div class="col text-left">
        <div class="col-auto mx-auto">
          <b-row>
            <slot name="buttons"></slot>
          </b-row>
        </div>
      </div>
    </b-row>
    <b-row class="p-3" v-if="showSearch">
      <b-col sm="7">
        <b-form-input
          id="input"
          placeholder=" جستجو"
          debounce="500"
          v-model="words"
        ></b-form-input>
      </b-col>
    </b-row>

    <slot name="table"></slot>
  </b-container>
</template>
<script>
export default {
  name: "TableLayout",
  props: ["title", "showSearch"],
  computed: {
    words: {
      get() {
        return this.$store.state.searchWord;
      },
      set(searchedword) {
        const searchWord = { words: searchedword };
        this.$store.dispatch("Feature/filteredFeatures", searchWord);
      },
    },
  },
};
</script>